import Vue from 'vue';
import response from "vue-resource/src/http/response";

const SITE_API = 'https://site-api.layka.me/';
// const SITE_API = 'http://94.232.104.253:85/';

const state = {
    tables: [],
    table: {},
    selectedGroup: 'common',
    tableData: [],
    parameters: [],
    user: null,
    interviews: [],
    apiUrl: SITE_API,
    parameterUrl: SITE_API + 'v1/parameters',
    imageUrl: SITE_API + 'images/',
    fileUrl: SITE_API + 'v1/files/file',
    //imageUrl : SITE_API + 'files/',
    filePathUrl: SITE_API + 'files/',
    cities: [
        { text: 'Все города', value: 0 },
        { text: 'Новокузнецк', value: 1 },
        { text: 'Осинники', value: 2 }
    ],
    fileThreads: [
        { text: 'Тарифы', value: 'tariffs' },
        { text: 'Юридическая информация', value: 'legal' },
    ],
};

const getters = {
    getSystemTables: state => state.tables,
    getSystemTable: state => state.table,
    getSystemTableData: state => state.tableData,
    getSystemAccessToken: state => state.user !== null ? (state.user.access_token) : null,
    getSystemLastError: state => state.lastError,
    getFileUrl: state => state.fileUrl,
    getApiUrl: state => state.apiUrl,
    getImageUrl: state => state.imageUrl,
    getFilePath: state => state.filePathUrl,
    getSystemCities: state => state.cities,
    getSystemInterviews: state => state.interviews,
    getFileThreads: state => state.fileThreads,
    getSystemParametersGroups: state => {
        let groups = [];
        state.parameters.forEach(item => {
            groups.push(item.group)
        });
        return groups;
    },
    getSystemParametersByGroup: state => {
        return state.parameters.filter(item => {
            if (item.group === state.selectedGroup)
                return item;
        });
    },
};

const mutations = {
    changeSystem(state, items) {
        state = Object.assign(state, items)
    },
};

const actions = {
    changeSystem({ commit }, items) {
        commit('changeSystem', items);
    },
    setSystemToken({ commit }, items) {
        commit('createProcess', 'systemToken');
        Vue.http.post(state.apiUrl + 'v1/users/login', {
            'login': items.login,
            'password': items.password
        }).then(response => {
            commit('changeSystem', {
                user: response.data,
                fileUrl: state.fileUrl + '?access-token=' + response.data.access_token
            });
            commit('setProcessSuccess', 'systemToken');
            items.router.push('/admins');
        }, response => {
            commit('setProcessFailed', { id: 'systemToken', message: response.body.message });
        });
    },
    setSystemTables({ commit }) {
        commit('createProcess', 'systemTables');
        if (state.user === null)
            return false;
        let url = state.apiUrl + 'v1/tables?sort=sort&access-token=' + state.user.access_token;
        Vue.http.get(url).then(response => {
            state.tables = response.data;
            commit('changeSystem', { tables: response.data });
            commit('setProcessSuccess', 'systemTables');
        }, response => {
            commit('changeSystem', { tables: [] });
            commit('setProcessFailed', { id: 'systemTables', message: response.body.message });
        });
    },
    setSystemTable({ commit }, table) {
        commit('changeSystem', { table: table });
    },
    setSystemInterviewsData({ commit }) {
        commit('createProcess', 'systemInterviewsData');
        if (state.user === null)
            return false;
        let url = state.apiUrl + state.table.version + '/interviews?access-token=' + state.user.access_token;
        Vue.http.get(url).then(response => {
            commit('changeSystem', { interviews: response.data });
            commit('setProcessSuccess', 'systemInterviewsData');
        }, response => {
            commit('changeSystem', { interviews: [] });
            commit('setProcessFailed', { id: 'systemInterviewsData', message: response.body.message });
        });
    },
    setSystemTableData({ commit }, table) {
        commit('createProcess', 'systemTableData');
        if (state.user === null)
            return false;
        let url = state.apiUrl + state.table.version + '/' + state.table.url + '?access-token=' + state.user.access_token + "&per-page=1000";
        Vue.http.get(url).then(response => {
            commit('changeSystem', { tableData: response.data });
            commit('setProcessSuccess', 'systemTableData');
        }, response => {
            commit('changeSystem', { tableData: [] });
            commit('setProcessFailed', { id: 'systemTableData', message: response.body.message });
        });
    },
    setSystemParameters({ commit }) {
        commit('createProcess', 'systemParameters');
        Vue.http.get(state.parameterUrl + '?sort=number&access-token=' + state.user.access_token).then(response => {
            commit('changeSystem', { parameters: response.data });
            commit('setProcessSuccess', 'systemParameters');
        }, response => {
            commit('changeSystem', { parameters: [] });
            commit('setProcessFailed', { id: 'systemParameters', message: response.body.message });
        });
    },
    setSystemParameter({ commit }, item) {
        let parameters = state.parameters;
        parameters[item.group].forEach((parameter, i) => {
            for (let entry in parameter) {
                if (parameter[entry].id === item.id) {
                    parameters[item.group][i][entry] = item;
                }
            }
        });
        commit('changeSystem', { parameters: parameters });
    },
    changeSystemTableData({ commit }, item) {
        commit('createProcess', 'systemTableUpdate');
        if (state.user === null)
            return false;
        if (item.id === 0 || item.id === undefined) {
            Vue.http.post(state.apiUrl + state.table.version + '/' + state.table.url + '?access-token=' + state.user.access_token, item).then(response => {
                commit('setProcessSuccess', 'systemTableUpdate');
            }, response => {
                commit('changeSystem', { tableData: [] });
                commit('setProcessFailed', { id: 'systemTableUpdate', message: response.body.message });
            });
        } else {
            Vue.http.patch(state.apiUrl + state.table.version + '/' + state.table.url + '/' + item.id + '?access-token=' + state.user.access_token, item).then(response => {
                let updatedItem = response.data;
                let table = state.tableData;
                table.forEach(function (item, iter) {
                    if (item.id === updatedItem.id)
                        table[iter] = updatedItem;
                });
                commit('changeSystem', { tableData: Object.assign([], table) });
                commit('setProcessSuccess', 'systemTableUpdate');
            }, response => {
                commit('changeSystem', { tableData: [] });
                commit('setProcessFailed', { id: 'systemTableUpdate', message: response.body.message });
            });
        }
    },
    deleteSystemTableData({ commit }, item) {
        commit('createProcess', 'systemTableDelete');
        if (state.user === null)
            return false;
        Vue.http.delete(state.apiUrl + state.table.version + '/' + state.table.url + '/' + item.id + '?access-token=' + state.user.access_token).then(response => {
            let table = state.tableData;
            table.forEach(function (updatedItem, iter) {
                if (item.id === updatedItem.id)
                    table.splice(iter, 1);
            });
            commit('changeSystem', { tableData: table });
            commit('setProcessSuccess', 'systemTableDelete');
        }, response => {
            commit('changeSystem', { tableData: [] });
            commit('setProcessFailed', { id: 'systemTableDelete', message: response.body.message });
        });
    },
    setSystemParameterGroup({ commit }, group) {
        commit('changeSystem', { selectedGroup: group });
    },
    loadCities({ commit }, callback) {
        let url = state.apiUrl + 'v1/cities?filter[visible]=1&sort=sort';
        Vue.http.get(url).then(response => {
            if (response.data.length > 0) {
                let newCities = [];
                newCities.push({ text: 'Все города', value: 0 });
                response.data.forEach((item) => {
                    newCities.push({ text: item.city, value: item.id });
                });
                state.cities = newCities;
                if (callback) callback(true, response.data);
            }
        });
    },
    getFiles({ commit }, data) {
        let url = state.apiUrl + 'v1/files?filter[thread]=' + data.thread + '&sort=sort';
        Vue.http.get(url).then(response => {
            if (data.callback) data.callback(true, response.data);
        }, response => {
            if (data.callback) data.callback(false, null);
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js